// extracted by css-extract-rspack-plugin
export default {"Container":"SharingPaneButton-module__Container___FWv0P","Disabled":"SharingPaneButton-module__Disabled___w5sU1"};